import React from "react";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  InputGroup,
} from "react-bootstrap";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

/**
 * Modal component for add/move/copy/delete student operations.
 */
export default function StudentManagementModal({
  // Visibility & view
  showModal,
  modalView,
  onHide,

  // "Add" form state
  addModalValidated,
  drivingSchool,
  firstName,
  middleName,
  lastName,
  dateOfBirth,
  permitNumber,
  permitIssueDate,
  email,
  phoneNumber,
  avaliableOptions,
  roadTestPackageOption,
  addCompletionCertificate,
  paymentType,

  // "Move" form state
  newEditMoveDate,
  moveError,

  // "Copy" form state
  newCopyMoveDate,
  copyError,

  // "Delete" state
  deleteError,

  // Shared
  loading,
  selectedStudent,
  APIDateStudentResults,

  // Callbacks
  onInputChange,
  onAddNewUser,
  onRadioPackageChange,
  onToggleCompletionCertificate,
  onSetDrivingSchool,
  onNewMoveDateChoice,
  onNewCopyDateChoice,
  onMoveStudent,
  onCopyStudent,
  onDeleteStudent,
  onStudentPickChange,
  roadTestDateOptions,
}) {
  function renderStudentPickerDropdown() {
    return (
      <Form.Group controlId="formControlsSelectStudent">
        <Form.Label>Select Student</Form.Label>
        <Form.Control
          name="selectedStudent"
          as="select"
          value={selectedStudent}
          onChange={onStudentPickChange}
        >
          {APIDateStudentResults.map((x, index) => {
            var name = x.fName + " " + x.lName;
            return (
              <option key={name + x.timestamp} value={index}>
                {name}
              </option>
            );
          })}
        </Form.Control>
      </Form.Group>
    );
  }

  return (
    <Modal
      size="lg"
      show={showModal}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          {modalView === "add" ? "Add New Student" : null}
          {modalView === "edit" ? "Edit Student" : null}
          {modalView === "copy" ? "Copy Student" : null}
          {modalView === "move" ? "Move Student" : null}
          {modalView === "delete" ? "Delete Student" : null}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {modalView === "add" ? (
          <Form
            noValidate
            validated={addModalValidated}
            onSubmit={onAddNewUser}
          >
            <InputGroup className="mb-3">
              <Form.Control
                name="drivingSchool"
                type="text"
                value={drivingSchool}
                placeholder="Enter Driving School Name (Optional)"
                onChange={onInputChange}
              />
              <InputGroup.Append>
                <Button
                  variant="outline-secondary"
                  onClick={onSetDrivingSchool}
                >
                  Parkway
                </Button>
              </InputGroup.Append>
            </InputGroup>

            <Row>
              <Col>
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  required
                  name="firstName"
                  type="text"
                  value={firstName}
                  placeholder="First Name"
                  onChange={onInputChange}
                />
                <Form.Control.Feedback type="invalid">
                  Please input a name.
                </Form.Control.Feedback>
              </Col>
              <Col>
                <Form.Label>Middle Name</Form.Label>
                <Form.Control
                  name="middleName"
                  type="text"
                  value={middleName}
                  placeholder="Middle Name (Optional)"
                  onChange={onInputChange}
                />
              </Col>
              <Col>
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  required
                  name="lastName"
                  type="text"
                  value={lastName}
                  placeholder="Last Name"
                  onChange={onInputChange}
                />
                <Form.Control.Feedback type="invalid">
                  Please input a name.
                </Form.Control.Feedback>
              </Col>
            </Row>
            <Form.Group controlId="dateOfBirth">
              <Form.Label>Date of Birth</Form.Label>
              <Form.Control
                required
                name="dateOfBirth"
                type="date"
                value={dateOfBirth}
                placeholder="MM/DD/YYYY"
                onChange={onInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Please input a DOB.
              </Form.Control.Feedback>
            </Form.Group>

            <Row>
              <Col>
                <Form.Group controlId="permitNumber">
                  <Form.Label>Permit Number</Form.Label>
                  <Form.Control
                    required
                    name="permitNumber"
                    type="text"
                    value={permitNumber}
                    placeholder="Enter text"
                    onChange={onInputChange}
                  />
                </Form.Group>
                <Form.Control.Feedback type="invalid">
                  Please input a permit number.
                </Form.Control.Feedback>
              </Col>
              <Col>
                <Form.Group controlId="permitDate">
                  <Form.Label>Permit Issue Date</Form.Label>
                  <Form.Control
                    required
                    name="permitIssueDate"
                    type="date"
                    value={permitIssueDate}
                    placeholder="MM/DD/YYYY"
                    onChange={onInputChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please input a permit issue date.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                required
                name="email"
                type="email"
                value={email}
                placeholder="Enter text"
                onChange={onInputChange}
                autoComplete="email"
              />
              <Form.Control.Feedback type="invalid">
                Please input a email address.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="phoneNumber">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                required
                name="phoneNumber"
                type="tel"
                value={phoneNumber}
                placeholder="Enter text"
                onChange={onInputChange}
                autoComplete="tel-national"
              />
              <Form.Control.Feedback type="invalid">
                Please input a phone number.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="paymentType">
              <Form.Label>Payment Type</Form.Label>
              <Form.Control
                required
                as="select"
                name="paymentType"
                value={paymentType}
                onChange={onInputChange}
              >
                <option value="" disabled>
                  Select a payment type
                </option>
                <option value="Cash">Cash</option>
                <option value="Credit Card">Credit Card</option>
                <option value="Check">Check</option>
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                Please select a payment type.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="roadTestPackage">
              <Form.Label>Road Test Package</Form.Label>
              {avaliableOptions.map((e, key) => {
                return (
                  <Form.Check
                    key={key}
                    required
                    checked={roadTestPackageOption === e.package}
                    name="roadTestPackage"
                    id={e.package}
                    type="radio"
                    label={e.package}
                    onChange={onRadioPackageChange}
                  />
                );
              })}
              <Form.Control.Feedback type="invalid">
                Please select a package.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Check
              inline
              label="Add Completion Certificate"
              type={"checkbox"}
              id={`addCompletionCertificate`}
              checked={addCompletionCertificate}
              onChange={onToggleCompletionCertificate}
            />
            <br></br>
            <Button type="submit">Add</Button>
            <br></br>
            <br></br>
          </Form>
        ) : null}

        {modalView === "move" ? (
          <div>
            {renderStudentPickerDropdown()}

            <Form.Label>Enter new Date</Form.Label>

            <CreatableSelect
              value={newEditMoveDate}
              onChange={(data) => onNewMoveDateChoice(data)}
              options={roadTestDateOptions}
            />
            {moveError.length > 0 ? (
              <div>{moveError}</div>
            ) : null}

            <Button
              disabled={loading}
              onClick={onMoveStudent}
            >
              {loading ? "Please wait. Move Processing" : "Move"}
            </Button>
            <div>
              The student will be moved as soon as the Move button is
              pressed.
            </div>
            <div>All email status and slot data will be cleared.</div>
          </div>
        ) : null}

        {modalView === "copy" ? (
          <div>
            {renderStudentPickerDropdown()}

            <Form.Label>Enter new Date</Form.Label>
            <Select
              value={newCopyMoveDate}
              onChange={(data) => onNewCopyDateChoice(data)}
              options={roadTestDateOptions}
            />
            {copyError.length > 0 ? (
              <div>{copyError}</div>
            ) : null}

            <Button
              disabled={loading}
              onClick={onCopyStudent}
            >
              {loading ? "Please wait. Copy Processing" : "Copy"}
            </Button>
            <div>
              The student will be copied as soon as the Copy button is
              pressed.
            </div>
          </div>
        ) : null}

        {modalView === "delete" ? (
          <div>
            {renderStudentPickerDropdown()}
            {deleteError.length > 0 ? (
              <div>{deleteError}</div>
            ) : null}

            <Button
              disabled={loading}
              variant="danger"
              onClick={onDeleteStudent}
            >
              {loading
                ? "Please wait. Delete Processing"
                : "Delete"}
            </Button>
            <div>
              The student will be deleted as soon as the Delete button is
              pressed.
            </div>
          </div>
        ) : null}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
